const AppConstants = {
	TabletWidth: 820,
	MobileWidth: 480,
} as const;
export default AppConstants;
